import { Component, OnInit,ViewChild } from '@angular/core';
import { PurchaseOrderService} from 'app/shared/services/purchase-order.service';
import { PurchaseOrder } from 'app/shared/types/purchase-order';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';


@Component({
  selector: 'app-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrls: ['./purchase-order-list.component.css']
})
export class PurchaseOrderListComponent implements OnInit {

  displayedColumns: string[] = ['poNo', 'date', 'supplier', 'amount','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  purchaseOrder : PurchaseOrder[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  constructor(
    private purchaseOrderService : PurchaseOrderService, 
    private router : Router, 
    private route : ActivatedRoute, 
    private toastr: ToastrService,
    private themeService: NbThemeService,
    private dialogService: DialogService,
    private authService: AuthService,
   ) { }

ngOnInit() {

    this.getAllPurchaseOrders();
    this.getControlPermissions();

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='PO'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

newButtonClick(){
  this.router.navigate(['../purchase-order'],{relativeTo : this.route});
  }


  getAllPurchaseOrders(){
  this.purchaseOrderService.getAll()
   .subscribe(
      (data) => {
                this.purchaseOrder = data; 
                this.dataSource = new  MatTableDataSource (this.purchaseOrder);  
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;      
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  

     
     
   }
 

   viewDetailsButtonClick(poNo:string){     
      this.router.navigate(['../purchase-order'],{queryParams : {'poNo':poNo},relativeTo : this.route});       
   }

   deleteButtonClick(poNo : string){   
     this.dialogService.openConfirmDialog('Are you sure you want to delete this purchase order?')
     .afterClosed().subscribe(res =>{
       if(res){
      this.purchaseOrderService.deletePurchaseOrder(poNo)
      .subscribe(
        (res) => {
                    this.toastr.success('Purchase order deleted successfully','Success');
                    this.getAllPurchaseOrders();
                    console.log(res);     
                  },        
        (err) =>  {
                    this.toastr.error('Failed to delete Purchase order','Failure');
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  }, 
          )

      } 
    });
 }


 applyFilter(){
  this.dataSource.filter =this.searchKey.trim().toLowerCase();

 }
 onSearchClear(){
   this.searchKey = "";
   this.applyFilter();
 }


}// en class
